import { type MetaFunction } from '@remix-run/node'

import { Footer, Header } from '#app/components'
import {
	Faqs,
	Hero,
	PrimaryFeatures,
	SecondaryFeatures,
	Testimonials,
} from '#app/components/marketing'
import { Wrapper } from '#app/components/ui'
import { useOptionalUser } from '#app/utils/user.ts'

export const meta: MetaFunction = () => [{ title: 'Top Timelines' }]

export default function Index() {
	const user = useOptionalUser()
	const isLoggedIn = user?.id ? true : false

	return (
		<main>
			<Header isLoggedIn={isLoggedIn} />
			<div className="flex w-full flex-col items-center">
				<Wrapper>
					<section className="space-y-4">
						<Hero />
						<PrimaryFeatures />
						<SecondaryFeatures />
						{/* <CallToAction /> */}
						<Testimonials />
						{/* <Pricing /> */}
						<Faqs />
					</section>
				</Wrapper>
			</div>
			<Footer />
		</main>
	)
}
